import { useMemo } from 'react';
import { OrdersWootTableRow } from '../../WootOrdersImport.interfaces';
import { DateTime } from 'luxon';
import { FiletypePdf, FiletypeXlsx } from 'react-bootstrap-icons';
import { getSalesforceUrlByWindowLocation } from '../../../common/common.entities';

interface WootFbaJourneyInvoicePreviewProps {
  row: OrdersWootTableRow
}

export default function WootFbaJourneyInvoicePreview(props: WootFbaJourneyInvoicePreviewProps) {
  const {row} = props
  const view = useMemo(() => {
    const order = JSON.parse(row.returnOrder)
    return <div>
      {/* TO */}
      <div className='beacon-header'>To: <span style={{fontWeight: 'normal'}}>accounting@nethealthshops.com</span></div>
      
      {/* SUBJECT */}
      <div className='beacon-header'>Subject: <span style={{fontWeight: 'normal'}}>WOOT! FBA - Return PO Invoice Request {DateTime.now().toLocaleString(DateTime.DATE_SHORT)} - {row.poNumber} / {row.wrpoNumber}</span></div>

      {/* ATTACHMENTS */}
      <div style={{display: 'flex', flexWrap: 'wrap'}}>
        <div className='beacon-card' style={{width: '15%', textAlign: 'center'}}>
          <FiletypePdf size='30' />
          <span className='beacon-label'> {row.sourcePoPdfPath?.split('/').pop()}</span>
        </div>
        <div className='beacon-card' style={{width: '15%', textAlign: 'center'}}>
          <FiletypeXlsx size='30' />
          <span className='beacon-label'> {row.sourcePoExcelPath?.split('/').pop()}</span>
        </div>
        <div className='beacon-card' style={{width: '15%', textAlign: 'center'}}>
          <FiletypePdf size='30' />
          <span className='beacon-label'> {row.sourceWrpoPdfPath?.split('/').pop()}</span>
        </div>
        <div className='beacon-card' style={{width: '15%', textAlign: 'center'}}>
          <FiletypeXlsx size='30' />
          <span className='beacon-label'> {row.sourceWrpoExcelPath?.split('/').pop()}</span>
        </div>
      </div>
      {/* BODY */}
      <div className='beacon-card'>
        <div className='beacon-header'>
          A WOOT! FBA event has been completed. Attached are the PDF and Excel files sent from WOOT! containing the original FBA purchase order {row.poNumber} and return FBA purchase order {row.wrpoNumber} documentation.
          <br/><br/>
          Original Purchase Order IA Groups:<br/>
          {JSON.parse(row.allocationIags).map(iag => (
            <div>
              <a target="_blank" rel="noopener noreferrer" href={`${getSalesforceUrlByWindowLocation(window.location.href)}/${iag.Id}`}>{iag.Shipment_Name__c}</a>
              <br/>
            </div>
          ))}
          <br/>
          Return Purchase Order IA Groups:<br/>
          {JSON.parse(row.returnIags).map(iag => (
            <div>
              <a target="_blank" rel="noopener noreferrer" href={`${getSalesforceUrlByWindowLocation(window.location.href)}/${iag.Id}`}>{iag.Shipment_Name__c}</a>
              <br/>
            </div>
          ))}
          <br/>
          Return Purchase Order Salesforce Order & Order Items:<br/>
          <a target="_blank" rel="noopener noreferrer" href={`${getSalesforceUrlByWindowLocation(window.location.href)}/${order.Id}`}>{order.Name}</a>
          <br/>
          <br/>
          Buy-From Vendor # VND04410
          <br/>
          RPO {row.wrpoNumber.replace('WRPO', '')} against PO {row.poNumber.replace('PO', '')}
          <br/>
          <br/>
          Please create and send an invoice to <a href='mailto:accountspayable@woot.com'>accountspayable@woot.com</a>
        </div>
      </div>
    </div>
  }, [row])

  return view
}